<template>
  <div class="about">
    <!-- 页面标题 -->
    <section class="page-header bg-info text-white py-5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-8">
            <h1 class="page-title">{{ $t('about.title') }}</h1>
            <p class="page-subtitle">{{ $t('about.subtitle') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 公司简介 -->
    <section class="company-intro py-5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 mb-4 mb-lg-0">
            <h2 class="section-title mb-4">{{ $t('about.introTitle') }}</h2>
            <p class="lead">{{ $t('about.introLead') }}</p>
            <p>{{ $t('about.introText') }}</p>
            <div class="intro-points mt-4">
              <div class="intro-point" v-for="item in introPoints" :key="item">
                <i class="fas fa-check-circle mr-2"></i>{{ item }}
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="about-qr-panel">
              <h5 class="about-qr-title mb-3">{{ $t('about.qrTitle') }}</h5>
              <p class="about-qr-subtitle mb-4">{{ $t('about.qrSubtitle') }}</p>
              <div class="row justify-content-center">
                <div class="col-6 mb-3" v-for="qr in qrCodes" :key="qr.id">
                  <div class="about-qr-box">
                    <img :src="qr.img" :alt="'企业微信二维码' + qr.id" class="about-qr-img">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 研发体系 -->
    <section class="company-history py-5 bg-light">
      <div class="container">
        <div class="section-header text-center mb-5">
          <h2 class="section-title">{{ $t('about.researchTitle') }}</h2>
          <p class="section-subtitle">{{ $t('about.researchSub') }}</p>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-12 mb-4 wow animate__fadeInUp" :data-wow-delay="(index * 0.12) + 's'" v-for="(team, index) in researchTeams" :key="team.id">
            <div class="research-card card h-100 border-0 shadow-sm">
              <div class="card-body">
                <div class="research-count text-primary">{{ team.count }}</div>
                <h5 class="research-title">{{ team.title }}</h5>
                <p class="research-desc text-muted mb-0">{{ team.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业文化 -->
    <section class="company-culture py-5">
      <div class="culture-bg-orbs"><span></span><span></span><span></span></div>
      <div class="container position-relative">
        <div class="section-header text-center mb-5">
          <h2 class="section-title text-white">{{ $t('about.cultureTitle') }}</h2>
          <p class="section-subtitle text-white-50">{{ $t('about.cultureSub') }}</p>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-3 col-md-6 mb-4 wow animate__fadeInUp" :data-wow-delay="(index * 0.12) + 's'"
               v-for="(culture, index) in cultures" :key="culture.id">
            <div class="culture-card h-100">
              <div class="culture-icon mb-3">
                <i :class="culture.icon"></i>
              </div>
              <h5 class="culture-title">{{ culture.title }}</h5>
              <p class="culture-description mb-0">{{ culture.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 资质与荣誉 -->
    <section class="certifications py-5">
      <div class="container">
        <div class="section-header text-center mb-5">
          <h2 class="section-title">{{ $t('about.certTitle') }}</h2>
          <p class="section-subtitle">{{ $t('about.certSub') }}</p>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-3 col-md-6 mb-4 wow animate__zoomIn" :data-wow-delay="(index * 0.12) + 's'"
               v-for="(cert, index) in certifications" :key="cert.id">
            <div class="cert-stat-card h-100 text-center">
              <div class="cert-stat-icon"><i :class="cert.icon"></i></div>
              <div class="cert-stat-num">
                <span class="num" :data-target="cert.num">{{ cert.display }}</span><span class="suffix">{{ cert.suffix }}</span>
              </div>
              <div class="cert-stat-label">{{ certText[index] && certText[index].label }}</div>
              <p class="cert-stat-desc mb-0">{{ certText[index] && certText[index].desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { WOW } from 'wowjs'
import qr1 from '../assets/qr/qr1.png'
import qr2 from '../assets/qr/qr2.png'
import qr3 from '../assets/qr/qr3.png'
import qr4 from '../assets/qr/qr4.png'

export default {
  name: 'About',
  data() {
    return {
      qrCodes: [
        { id: 1, img: qr1 },
        { id: 2, img: qr2 },
        { id: 3, img: qr3 },
        { id: 4, img: qr4 }
      ],
      cultureIcons: ['fas fa-eye', 'fas fa-lightbulb', 'fas fa-microchip', 'fas fa-handshake'],
      certifications: [
        { id: 1, icon: 'fas fa-certificate', num: 28, suffix: '', display: 0 },
        { id: 2, icon: 'fas fa-file-code', num: 12, suffix: '', display: 0 },
        { id: 3, icon: 'fas fa-clipboard-check', num: 3, suffix: '', display: 0 },
        { id: 4, icon: 'fas fa-trophy', num: 10, suffix: '+', display: 0 }
      ]
    }
  },
  computed: {
    introPoints() {
      return this.$t('about.introPoints')
    },
    researchTeams() {
      return this.$t('about.researchTeams').map((t, i) => ({ id: i + 1, count: t.count, title: t.title, desc: t.desc }))
    },
    cultures() {
      return this.$t('about.cultures').map((c, i) => ({ id: i + 1, icon: this.cultureIcons[i], title: c.title, description: c.description }))
    },
    certText() {
      return this.$t('about.certs')
    }
  },
  mounted() {
    this.initWOW()
    this.initCounters()
  },
  beforeDestroy() {
    if (this._io) this._io.disconnect()
  },
  methods: {
    initWOW() {
      try {
        // eslint-disable-next-line no-new
        new WOW({ boxClass: 'wow', animateClass: 'animate__animated', offset: 60, mobile: true, live: false }).init()
      } catch (e) { /* noop */ }
    },
    initCounters() {
      const section = this.$el.querySelector('.certifications')
      if (!section || typeof IntersectionObserver === 'undefined') {
        this.certifications.forEach(c => { c.display = c.num })
        return
      }
      this._io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.runCount()
            this._io.disconnect()
          }
        })
      }, { threshold: 0.3 })
      this._io.observe(section)
    },
    runCount() {
      const duration = 1200
      const start = performance.now()
      const step = (now) => {
        const p = Math.min((now - start) / duration, 1)
        const ease = 1 - Math.pow(1 - p, 3)
        this.certifications.forEach((c) => {
          c.display = Math.round(c.num * ease)
        })
        if (p < 1) requestAnimationFrame(step)
      }
      requestAnimationFrame(step)
    }
  }
}
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #17a2b8 0%, #20c997 100%);
}

/* 公司简介 - 柔和渐变 + 点阵渲染，避免大面积纯白 */
.company-intro {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(900px 420px at 88% -12%, rgba(47, 128, 237, 0.10), transparent 60%),
    radial-gradient(720px 360px at -6% 112%, rgba(32, 201, 151, 0.10), transparent 60%),
    linear-gradient(180deg, #ffffff 0%, #f2f8ff 100%);
}

.company-intro::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(47, 128, 237, 0.07) 1px, transparent 1px);
  background-size: 22px 22px;
  -webkit-mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.7), transparent 72%);
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.7), transparent 72%);
  pointer-events: none;
}

.company-intro > .container {
  position: relative;
  z-index: 1;
}

/* 研发体系 - 浅色渐变 + 光晕 */
.company-history {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #eef4fb 0%, #f3f9f6 100%) !important;
}

.company-history::after {
  content: '';
  position: absolute;
  top: -140px;
  right: -120px;
  width: 380px;
  height: 380px;
  border-radius: 50%;
  background: radial-gradient(circle at center, rgba(47, 128, 237, 0.14), transparent 70%);
  pointer-events: none;
}

.company-history > .container {
  position: relative;
  z-index: 1;
}

.timeline {
  position: relative;
  padding: 2rem 0;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #e9ecef;
  transform: translateX(-50%);
}

.timeline-item {
  position: relative;
  margin-bottom: 3rem;
  display: flex;
  align-items: center;
}

.timeline-item:nth-child(odd) {
  flex-direction: row-reverse;
}

.timeline-marker {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}

.timeline-content {
  width: 45%;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* 企业文化 - 深色渲染 + 动效 */
.company-culture {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #0c2342 0%, #123a6b 55%, #0e2c52 100%);
}

.about-qr-panel {
  background: #fff;
  border: 1px solid #e8eef6;
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(0, 40, 80, 0.08);
  padding: 1.2rem 1rem 0.8rem;
}

.about-qr-title {
  color: #1f3350;
  font-weight: 700;
  text-align: center;
}

.about-qr-subtitle {
  color: #6c7f96;
  font-size: 0.92rem;
  text-align: center;
}

.about-qr-box {
  background: #fff;
  border: 1px solid #eef3f9;
  border-radius: 10px;
  padding: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.about-qr-box:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.12);
}

.about-qr-img {
  width: 100%;
  display: block;
  border-radius: 8px;
}

.intro-points {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.6rem 1.2rem;
}

.intro-point {
  color: #3a4f68;
  font-size: 0.92rem;
  line-height: 1.6;
}

.intro-point i {
  color: #20c997;
}

.culture-bg-orbs span {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.45;
  animation: orbFloat 12s ease-in-out infinite;
}

.culture-bg-orbs span:nth-child(1) {
  width: 320px; height: 320px; top: -80px; left: -60px;
  background: #2f80ed;
}

.culture-bg-orbs span:nth-child(2) {
  width: 280px; height: 280px; bottom: -100px; right: 8%;
  background: #20c997; animation-delay: -4s;
}

.culture-bg-orbs span:nth-child(3) {
  width: 220px; height: 220px; top: 30%; right: 38%;
  background: #6c5ce7; opacity: 0.3; animation-delay: -8s;
}

@keyframes orbFloat {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(20px, -26px) scale(1.12); }
}

.culture-card {
  padding: 2.2rem 1.5rem;
  border-radius: 18px;
  text-align: center;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(8px);
  transition: transform 0.35s ease, box-shadow 0.35s ease, background 0.35s ease;
}

.culture-card:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.14);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.3);
}

.culture-icon {
  width: 76px;
  height: 76px;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.9rem;
  color: #fff;
  background: linear-gradient(135deg, #4f9bff 0%, #20c997 100%);
  box-shadow: 0 8px 22px rgba(32, 201, 151, 0.4);
  transition: transform 0.35s ease;
}

.culture-card:hover .culture-icon {
  transform: scale(1.12) rotate(6deg);
}

.culture-title {
  color: #fff;
  font-weight: 700;
  margin-bottom: 0.6rem;
}

.culture-description {
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.92rem;
  line-height: 1.7;
}

/* 资质与荣誉 - 数字滚动 + 卡片动效 */
.certifications {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(820px 380px at 8% 0%, rgba(32, 201, 151, 0.12), transparent 60%),
    radial-gradient(680px 360px at 100% 100%, rgba(47, 128, 237, 0.10), transparent 60%),
    linear-gradient(180deg, #f7fafd 0%, #eef4fb 100%);
}

.certifications > .container {
  position: relative;
  z-index: 1;
}

.cert-stat-card {
  position: relative;
  padding: 2.2rem 1.2rem 1.8rem;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 6px 24px rgba(31, 51, 80, 0.08);
  overflow: hidden;
  transition: transform 0.35s ease, box-shadow 0.35s ease;
}

.cert-stat-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 5px;
  background: linear-gradient(90deg, #2f80ed, #20c997);
}

.cert-stat-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 18px 42px rgba(31, 51, 80, 0.16);
}

.cert-stat-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 1rem;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  color: #2f80ed;
  background: linear-gradient(135deg, rgba(47, 128, 237, 0.12), rgba(32, 201, 151, 0.12));
}

.cert-stat-num {
  font-size: 2.8rem;
  font-weight: 800;
  line-height: 1;
  background: linear-gradient(135deg, #2f80ed, #20c997);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.cert-stat-num .suffix {
  -webkit-text-fill-color: transparent;
}

.cert-stat-label {
  margin-top: 0.5rem;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1f3350;
}

.cert-stat-desc {
  margin-top: 0.4rem;
  font-size: 0.85rem;
  color: #7b8aa0;
}

.team-member {
  transition: transform 0.3s ease;
}

.team-member:hover {
  transform: translateY(-5px);
}

.member-photo {
  height: 260px;
  object-fit: cover;
  object-position: top center;
}

.member-avatar-fallback {
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #17a2b8 0%, #20c997 100%);
  color: #fff;
  font-size: 5rem;
}

.research-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.research-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12) !important;
}

.research-count {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.cert-card {
  padding: 0.5rem 0;
}

.cert-photo {
  max-height: 360px;
}

.member-social .btn {
  margin: 0 2px;
}

.cert-logo {
  max-height: 80px;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.cert-logo:hover {
  opacity: 1;
}

.stat-number {
  font-weight: bold;
  color: #17a2b8;
}

.stat-label {
  color: #6c757d;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .intro-points {
    grid-template-columns: 1fr;
  }

  .timeline::before {
    left: 20px;
  }
  
  .timeline-item {
    flex-direction: row !important;
    padding-left: 50px;
  }
  
  .timeline-marker {
    left: 20px !important;
  }
  
  .timeline-content {
    width: 100%;
  }
}
</style>